import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateFranchiseRequestService=async(data)=>{
    try {
        const result = await post(`api/admin/franchise_request/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateFranchiseRequestService=async(data,id)=>{
    try {
        const result = await put(`api/admin/franchise_request/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetFranchiseRequestService=async(page=1,status,text,from_date,to_date,city)=>{
    try {
        const result = await get(`api/admin/franchise_request/get?page=${page}&status=${status}&text=${text}&from_date=${from_date}&to_date=${to_date}&city=${city}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteFranchiseRequestService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/franchise_request/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

